import React from 'react'

export default function MemberPurchasedProducts({ familyProductItems }) {
    const productsArray = Array.isArray(familyProductItems)
        ? familyProductItems
        : [];
    return (
        <>
            <h4 className="title text-capitalize mt-5">Purchased Products</h4>
            {productsArray.length > 0 &&
                <div className="row pt-4">
                    {productsArray.map((product) => (
                        <div className="col-md-6 col-lg-4">
                            <div className="prelist-product p-3">
                                <div className="product-image">
                                    <img src={product.pro_image} alt="" className="img-fluid d-block mx-auto" />
                                </div>
                                <div className="row align-items-center mt-5">
                                    <div className="col-7">
                                        <h6>{product.product_name}</h6>
                                    </div>
                                    <div className="col-5">
                                        <button className="btn btn-brandgreengrad d-block ml-auto">$ {product.price}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {productsArray.length == 0 &&
                <div >
                    <p className="text-center">No Records Found</p>
                </div>
            }
        </>
    )
}
